// extracted by mini-css-extract-plugin
module.exports = {"superpower-webgl":"SuperpowerWebgl_superpower-webgl__05Htd","superpowerWebgl":"SuperpowerWebgl_superpower-webgl__05Htd","isInViewWrap":"SuperpowerWebgl_isInViewWrap__sQyVT"};